(() => {
  window.addEventListener("brightcoveloaded", (e) => {
    const videos = document.querySelectorAll('.feature_sa .brightcove_player__video');
    const featureLabels = document.querySelectorAll('.feature_sa__label');

    videos && featureLabels && featureLabels.forEach(label => label.addEventListener("click", () => {
      for (let i = 0; i < videos.length; i++) {
        videojs.getPlayer(videos[i].id).pause();
      }
    }));
  });
})();
